const layout = () => import('../components/layout.vue');

export default [
  // 全屏路由
  { path: '/', component: () => import('@/pages/login/welcome.vue'), meta: {} },
  { path: '/login', component: () => import('@/pages/login/login.vue'), meta: {} },
  { path: '/i18n', component: () => import('@/pages/i18n/i18n.vue'), meta: {} },
  { path: '/wechatlogin', component: () => import('@/pages/login/wechat_login.vue'), meta: {} },
  { path: '/findpassword', component: () => import('@/pages/login/find_password.vue'), meta: {} },
  { path: '/resetpassword', component: () => import('@/pages/login/reset_password.vue'), meta: {} },
  { path: '/bindaccount', component: () => import('@/pages/login/bind_account.vue'), meta: {} },
  {
    path: '/admin',
    component: layout,
    meta: { title: '仪表盘' },
    children: [
      { path: 'dashboard', component: () => import('@/pages/base/dashboard/dashboard.vue'), meta: { title: '仪表盘', keep: 'dashboard' } }, // 菜单栏上
    ],
  },
  // 套壳路由
  // {
  //   path: '/home',
  //   component: layout,
  //   children: [{ path: '', component: () => import('@/pages/home.vue'), meta: { keep: 'home' } }]
  // },
  {
    path: '/redirect',
    component: layout,
    children: [{ path: '/redirect/:path(.*)', component: () => import('@/components/redirect.vue'), meta: {} }],
  },
  {
    path: '/',
    component: layout,
    children: [{ path: 'userset', component: () => import('@/pages/base/userset/userset.vue'), meta: { title: '个人信息', keep: 'userset' } }],
  },
  {
    path: '/',
    component: layout,
    children: [{ path: 'waitdevice', component: () => import('@/pages/base/waitdevice/waitdevice.vue'), meta: { title: '待分配设备', keep: 'waitdevice' } }],
  },

  // 基础设置
  {
    path: '/company',
    component: layout,
    meta: { title: '公司管理' },
    children: [
      { path: 'user', component: () => import('@/pages/base/user/user.vue'), meta: { title: '员工管理', keep: 'user' } },
      { path: 'user/add', component: () => import('@/pages/base/userItem/user_item.vue'), meta: { title: '新增用户', keep: 'user_item' } },
      { path: 'user/edit', component: () => import('@/pages/base/userItem/user_item.vue'), meta: { title: '编辑用户', keep: 'user_item' } },
      {
        path: 'department',
        component: () => import('@/pages/base/department/department.vue'),
        meta: { title: '部门管理', keep: 'department' },
      },
      {
        path: 'organdevice',
        component: () => import('@/pages/base/organdevice/organdevice.vue'),
        meta: { title: '设备分配', keep: 'organdevice' },
      },
      {
        path: 'role',
        component: () => import('@/pages/base/role/role.vue'),
        meta: { title: '岗位管理', keep: 'role' },
      },
    ],
  },
  {
    path: '/',
    component: layout,
    meta: { title: '数据字典' },
    children: [{ path: 'dictionary', component: () => import('@/pages/base/dictionary/dictionary.vue'), meta: { title: '数据字典', keep: 'dictionary' } }],
  },
  {
    path: '/language',
    component: layout,
    meta: { title: '多语言管理' },
    children: [
      { path: 'config', component: () => import('@/pages/base/language/language.vue'), meta: { title: '多语言设置', keep: 'language' } },
      { path: 'key', component: () => import('@/pages/base/languagekey/languageKey.vue'), meta: { title: '多语言维护', keep: 'languageKey' } },
    ],
  },
  {
    path: '/',
    component: layout,
    meta: { title: '通知管理' },
    children: [{ path: 'notice', component: () => import('@/pages/base/notice/notice.vue'), meta: { title: '通知管理', keep: 'notice' } }],
  },
  {
    path: '/msg',
    component: layout,
    meta: { title: '消息管理' },
    children: [
      {
        path: 'template',
        component: () => import('@/pages/base/messagetpl/messagetpl.vue'),
        meta: { title: '消息模板', keep: 'messagetpl' },
      },
      {
        path: 'messagerule',
        component: () => import('@/pages/base/messagerule/messagerule.vue'),
        meta: { title: '推送规则', keep: 'messagerule' },
      },
      {
        path: 'pushConfig',
        component: () => import('@/pages/base/pushConfig/pushConfig.vue'),
        meta: { title: '消息列表', keep: 'pushConfig' },
      },
      {
        path: 'center',
        component: () => import('@/pages/base/messageCenter/messageCenter.vue'),
        meta: { title: '消息中心', keep: 'messageCenter' },
      },
    ],
  },
  {
    path: '/logger',
    component: layout,
    meta: { title: '日志管理' },
    children: [
      { path: 'sys', component: () => import('@/pages/base/logger/sys/sys.vue'), meta: { title: '操作日志', keep: 'loggerSys' } },
      { path: 'login', component: () => import('@/pages/base/logger/login/login'), meta: { title: '登录日志', keep: 'loggerLogin' } },
      { path: 'u8', component: () => import('@/pages/base/logger/u8/u8'), meta: { title: 'U8接口日志', keep: 'u8' } },
    ],
  },
  {
    path: '/menufunc',
    component: layout,
    meta: { title: '功能菜单管理' },
    children: [
      { path: 'menu', component: () => import('@/pages/base/menu/menu.vue'), meta: { title: '系统菜单管理', keep: 'menu' } },
      { path: 'function', component: () => import('@/pages/base/function/function.vue'), meta: { title: '模块功能管理', keep: 'func' } },
    ],
  },
  {
    path: '/',
    component: layout,
    meta: { title: '表格字段管理' },
    children: [{ path: 'table', component: () => import('@/pages/base/tables/tables.vue'), meta: { title: '表格字段管理', keep: 'tables' } }],
  },
  {
    path: '/system',
    component: layout,
    meta: { title: '系统管理' },
    children: [{ path: 'application', component: () => import('@/pages/base/application/application.vue'), meta: { title: '应用管理', keep: 'application' } }],
  },
  {
    path: '/',
    component: layout,
    meta: { title: '区域管理' },
    children: [{ path: 'serviceArea', component: () => import('@/pages/base/serviceArea/serviceArea.vue'), meta: { title: '区域管理', keep: 'serviceArea' } }],
  },
  {
    path: '/examine',
    component: layout,
    meta: { title: '审批中心' },
    children: [
      { path: 'myApproval', component: () => import('@/pages/crm/examine/myApproval.vue'), meta: { title: '我的审批', keep: 'myApproval' } }, // 菜单栏上
      { path: 'approvalDetail', component: () => import('@/pages/crm/examine/approvalDetail.vue'), meta: { title: '审批详情' } }, // 菜单栏上
      { path: 'approvalProcess', component: () => import('@/pages/base/examine/approvalProcess.vue'), meta: { title: '审批流程管理', keep: 'approvalProcess' } },
      { path: 'approvalProcess/addApprovalProcess', component: () => import('@/pages/base/examine/processItem.vue'), meta: { title: '新增审批流程', keep: 'processItem' } },
      { path: 'approvalProcess/editApprovalProcess', component: () => import('@/pages/base/examine/processItem.vue'), meta: { title: '编辑审批流程', keep: 'processItem' } },
    ],
  },
  {
    path: '/',
    component: layout,
    meta: { title: 'APP版本管理' },
    children: [{ path: 'appversion', component: () => import('@/pages/base/appVersion/appVersion.vue'), meta: { title: 'APP版本管理', keep: 'appversion' } }],
  },
  {
    path: '/',
    component: layout,
    meta: { title: '运维报告' },
    children: [{ path: 'operation', component: () => import('@/pages/base/operation/operation.vue'), meta: { title: '运维报告', keep: 'operation' } }],
  },
  // 设备管理
  {
    path: '/factoryTest',
    component: layout,
    meta: { title: '工厂测试' },
    children: [
      {
        path: 'battery',
        component: () => import('@/pages/dms/battery/battery.vue'),
        meta: { title: '电池测试', keep: 'battery' },
      },
      {
        path: 'entire',
        component: () => import('@/pages/dms/entire/entire.vue'),
        meta: { title: '整机测试', keep: 'entire' },
      },
    ],
  },
  {
    path: '/factorymanage',
    component: layout,
    meta: { title: '工厂管理' },
    children: [
      {
        path: 'batteryManagement',
        component: () => import('@/pages/dms/batteryManagement/batteryManagement.vue'),
        meta: { title: '电池管理', keep: 'batteryManagement' },
      },
      {
        path: 'stock',
        component: () => import('@/pages/dms/factoryStock/factoryStock.vue'),
        meta: { title: '设备库存', keep: 'factoryStock' },
      },
      {
        path: 'inventory',
        component: () => import('@/pages/dms/partInventory/part_inventory.vue'),
        meta: { title: '零件库存', keep: 'partInventory' },
      },
    ],
  },
  {
    path: '/stock',
    component: layout,
    meta: { title: '库存管理' },
    children: [
      {
        path: 'instock',
        component: () => import('@/pages/dms/instock/instock.vue'),
        meta: { title: '新机入库', keep: 'instock' },
      },
      {
        path: 'manage',
        component: () => import('@/pages/dms/stock/stock_manage.vue'),
        meta: { title: '库存管理', keep: 'stockManage' },
      },
      {
        path: 'record',
        component: () => import('@/pages/dms/stock/stock_record.vue'),
        meta: { title: '出入库记录', keep: 'stockRecord' },
      },
      {
        path: 'renovateRecord',
        component: () => import('@/pages/dms/renovateRecord/renovateRecord.vue'),
        meta: { title: '设备翻新记录', keep: 'renovateRecord' },
      },
    ],
  },
  {
    path: '/device',
    component: layout,
    meta: { title: '设备管理' },
    children: [
      {
        path: 'mydevice',
        component: () => import('@/pages/dms/device/mydevice.vue'),
        meta: { title: '实时信息', keep: 'mydevice' },
      },
      {
        path: 'mybizdevice',
        component: () => import('@/pages/dms/device/mybizdevice.vue'),
        meta: { title: '业务信息', keep: 'mybizdevice' },
      },
      {
        path: 'deviceComponent',
        component: () => import('@/pages/dms/device/deviceComponent.vue'),
        meta: { title: '设备组件', keep: 'deviceComponent' },
      },
      {
        path: 'map',
        component: () => import('@/pages/dms/deviceMap/device_map.vue'),
        meta: { title: '设备地图', keep: 'devicemap' },
      },
      {
        path: 'maps',
        component: () => import('@/pages/dms/deviceMap/device_map_test.vue'),
        meta: { title: '设备地图2', keep: 'devicemaps' },
      },
      {
        path: 'scrapRecord',
        component: () => import('@/pages/dms/scrapRecord/scrapRecord.vue'),
        meta: { title: '报废申请', keep: 'scrapRecord' },
      },
      {
        path: 'lisence',
        component: () => import('@/pages/dms/lisence/lisence.vue'),
        meta: { title: '激活记录', keep: 'lisence' },
      },
      {
        path: 'bizTypeRecord',
        component: () => import('@/pages/dms/bizTypeRecord/bizTypeRecord.vue'),
        meta: { title: '设备类型变更记录', keep: 'bizTypeRecord' },
      },
      {
        path: 'locationRecord',
        component: () => import('@/pages/dms/locationRecord/locationRecord.vue'),
        meta: { title: '项目变更记录', keep: 'locationRecord' },
      },
      {
        path: 'simServiceRecord',
        component: () => import('@/pages/dms/simServiceRecord/simServiceRecord.vue'),
        meta: { title: '设备数据服务记录', keep: 'simServiceRecord' },
      },
      {
        path: 'route',
        component: () => import('@/pages/dms/routeManage/routeManage'),
        meta: { title: '路线管理', keep: 'route' },
      },
    ],
  },
  {
    path: '/product',
    component: layout,
    meta: { title: '产品管理' },
    children: [
      {
        path: 'code',
        component: () => import('@/pages/dms/productCode/productCode.vue'),
        meta: { title: '产品型号', keep: 'productCode' },
      },
      {
        path: 'list',
        component: () => import('@/pages/dms/product/product.vue'),
        meta: { title: '产品列表', keep: 'product' },
      },

      { path: 'add', component: () => import('@/pages/dms/product/children/product_item.vue'), meta: { title: '产品新增' } },
      { path: 'edit', component: () => import('@/pages/dms/product/children/product_item.vue'), meta: { title: '产品编辑' } },
    ],
  },
  {
    path: '/',
    component: layout,
    meta: { title: '站点管理' },
    children: [{ path: 'site', component: () => import('@/pages/dms/website/website.vue'), meta: { title: '站点管理', keep: 'site' } }],
  },
  {
    path: '/',
    component: layout,
    meta: { title: '开机卡管理' },
    children: [{ path: 'card', component: () => import('@/pages/dms/bootCard/bootCard.vue'), meta: { title: '开机卡管理', keep: 'bootCard' } }],
  },
  {
    path: '/simManage',
    component: layout,
    meta: { title: 'SIM卡管理' },
    children: [
      { path: 'list', component: () => import('@/pages/dms/sim/sim.vue'), meta: { title: 'SIM卡管理', keep: 'sim' } },
      { path: 'simOperationRecord', component: () => import('@/pages/dms/sim/operationRecord.vue'), meta: { title: 'SIM卡操作记录', keep: 'simOperationRecord' } },
      { path: 'networkFlowUsedRecord', component: () => import('@/pages/dms/sim/networkFlowUsedRecord.vue'), meta: { title: '流量使用记录', keep: 'networkFlowUsedRecord' } },
      { path: 'simBindingRecord', component: () => import('@/pages/dms/sim/simBindingRecord.vue'), meta: { title: '设备绑定记录', keep: 'simBindingRecord' } },
    ],
  },
  {
    path: '/ispSim',
    component: layout,
    meta: { title: 'ISP SIM管理' },
    children: [
      { path: 'ispSimList', component: () => import('@/pages/dms/ispSim/ispSimList.vue'), meta: { title: 'SIM卡管理列表', keep: 'ispSimList' } },
      { path: 'ispStatusChangeRecord', component: () => import('@/pages/dms/ispSim/statusChangeRecord.vue'), meta: { title: '状态变更记录', keep: 'ispStatusChangeRecord' } },
      { path: 'ispFlowUseRecord', component: () => import('@/pages/dms/ispSim/flowUseRecord.vue'), meta: { title: '状态变更记录', keep: 'ispFlowUseRecord' } },
      { path: 'ispTask', component: () => import('@/pages/dms/ispSim/ispTask.vue'), meta: { title: '任务管理', keep: 'ispTask' } },
    ],
  },
  {
    path: '/',
    component: layout,
    meta: { title: '项目管理' },
    children: [{ path: 'project', component: () => import('@/pages/dms/project/project.vue'), meta: { title: '项目管理', keep: 'project' } }],
  },
  {
    path: '/iot',
    component: layout,
    meta: { title: 'IOT管理' },
    children: [
      { path: 'protocol', component: () => import('@/pages/dms/protocol/protocol.vue'), meta: { title: '协议管理', keep: 'protocol' } },
      { path: 'protocol/edit', component: () => import('@/pages/dms/protocol/protocol_item.vue'), meta: { title: '编辑协议', keep: 'protocol_item' } },
      { path: 'protocol/add', component: () => import('@/pages/dms/protocol/protocol_item.vue'), meta: { title: '新增协议', keep: 'protocol_item' } },
      {
        path: 'resource',
        component: () => import('@/pages/dms/resource/resource.vue'),
        meta: { title: '资源管理', keep: 'resource' },
      },
      { path: 'firmwareTask', component: () => import('@/pages/dms/firmwareTask/firmwareTask.vue'), meta: { title: '任务管理', keep: 'firmwareTask' } },
      { path: 'firmwareTask/add', component: () => import('@/pages/dms/firmwareTask/children/firmwareTask_addItem.vue'), meta: { title: '添加固件任务', keep: 'firmwareTask_item' } },
      { path: 'firmwareTask/edit', component: () => import('@/pages/dms/firmwareTask/children/firmwareTask_addItem.vue'), meta: { title: '编辑固件任务', keep: 'firmwareTask_item' } },
      {
        path: 'malfunction',
        component: () => import('@/pages/dms/event/event.vue'),
        meta: { title: '事件代码', keep: 'alarm' },
      },
    ],
  },
  // CRM管理
  {
    path: '/contract',
    component: layout,
    meta: { title: '合同订单' },
    children: [
      {
        path: 'management',
        component: () => import('@/pages/crm/contractManagement/contractManagement.vue'),
        meta: { title: '租赁合同', keep: 'contractManagement' },
      },
      {
        path: 'management/leaseadd',
        component: () => import('@/pages/crm/contractComponents/leaseaManagement_item.vue'),
        meta: { title: '新增租赁合同', keep: 'leaseaManagement_item' },
      },
      {
        path: 'management/leaseedit',
        component: () => import('@/pages/crm/contractComponents/leaseaManagement_item.vue'),
        meta: { title: '编辑租赁合同', keep: 'leaseaManagement_item' },
      },
      {
        path: 'management/leasecopy',
        component: () => import('@/pages/crm/contractComponents/leaseaManagement_item.vue'),
        meta: { title: '拷贝租赁合同', keep: 'leaseaManagement_item' },
      },
      {
        path: 'management/campadd',
        component: () => import('@/pages/crm/contractComponents/campManagement_item.vue'),
        meta: { title: '新增框架协议', keep: 'campManagement_item' },
      },
      {
        path: 'management/campedit',
        component: () => import('@/pages/crm/contractComponents/campManagement_item.vue'),
        meta: { title: '编辑框架协议', keep: 'campManagement_item' },
      },
      {
        path: 'management/campcopy',
        component: () => import('@/pages/crm/contractComponents/campManagement_item.vue'),
        meta: { title: '拷贝框架协议', keep: 'campManagement_item' },
      },
      {
        path: 'management/leasecontinueadd',
        component: () => import('@/pages/crm/contractComponents/leaseaManagement_item_continue.vue'),
        meta: { title: '期末续租', keep: 'leaseaManagementItemContinue' },
      },
      {
        path: 'management/leasecontinueedit',
        component: () => import('@/pages/crm/contractComponents/leaseaManagement_item_continue.vue'),
        meta: { title: '编辑期末续租', keep: 'leaseaManagementItemContinue' },
      },
      {
        path: 'management/leaserentadd',
        component: () => import('@/pages/crm/contractComponents/leaseaManagement_item_rent.vue'),
        meta: { title: '新增试用转租赁', keep: 'leaseaManagement_item_rent' },
      },
      {
        path: 'management/leaserentedit',
        component: () => import('@/pages/crm/contractComponents/leaseaManagement_item_rent.vue'),
        meta: { title: '编辑试用转租赁', keep: 'leaseaManagement_item_rent' },
      },
      {
        path: 'agreementOrder',
        component: () => import('@/pages/crm/agreementOrder/agreementOrder.vue'),
        meta: { title: '协议订单', keep: 'agreementOrder' },
      },
      {
        path: 'agreementOrder/add',
        component: () => import('@/pages/crm/contractComponents/inventoryManagement_item.vue'),
        meta: { title: '新增协议订单', keep: 'inventoryManagement_item' },
      },
      {
        path: 'agreementOrder/edit',
        component: () => import('@/pages/crm/contractComponents/inventoryManagement_item.vue'),
        meta: { title: '编辑协议订单', keep: 'inventoryManagement_item' },
      },
      {
        path: 'agreementOrder/copy',
        component: () => import('@/pages/crm/contractComponents/inventoryManagement_item.vue'),
        meta: { title: '拷贝协议订单', keep: 'inventoryManagement_item' },
      },
      {
        path: 'agreementOrder/leaseaorderadd',
        component: () => import('@/pages/crm/contractComponents/leaseaManagement_item_rent.vue'),
        meta: { title: '新增试用转协议', keep: 'leaseaManagement_item_rent' },
      },
      {
        path: 'agreementOrder/leaseaorderedit',
        component: () => import('@/pages/crm/contractComponents/leaseaManagement_item_rent.vue'),
        meta: { title: '编辑试用转协议', keep: 'leaseaManagement_item_rent' },
      },
      {
        path: 'agreementOrder/continue',
        component: () => import('@/pages/crm/contractComponents/agreementOrder_item_continue.vue'),
        meta: { title: '期末续租', keep: 'agreementOrderItemContinue' },
      },
      {
        path: 'agreementOrder/continueedit',
        component: () => import('@/pages/crm/contractComponents/agreementOrder_item_continue.vue'),
        meta: { title: '期末续租', keep: 'agreementOrderItemContinue' },
      },
      {
        path: 'trialOrder',
        component: () => import('@/pages/crm/trialOrder/trialOrderManagement.vue'),
        meta: { title: '试用订单', keep: 'trialOrderManagement' },
      },
      {
        path: 'trialOrder/add',
        component: () => import('@/pages/crm/contractComponents/tryManagement_item.vue'),
        meta: { title: '新增试用订单', keep: 'tryManagement_item' },
      },
      {
        path: 'trialOrder/edit',
        component: () => import('@/pages/crm/contractComponents/tryManagement_item.vue'),
        meta: { title: '编辑试用订单', keep: 'tryManagement_item' },
      },
      {
        path: 'trialOrder/copy',
        component: () => import('@/pages/crm/contractComponents/tryManagement_item.vue'),
        meta: { title: '拷贝试用订单', keep: 'tryManagement_item' },
      },
      {
        path: 'contractchange',
        component: () => import('@/pages/crm/contractChangeManage/contract_change.vue'),
        meta: { title: '合同变更记录', keep: 'contract_change' },
      },
      {
        path: 'breakRecord',
        component: () => import('@/pages/crm/breakRecord/breakRecord.vue'),
        meta: { title: '违约记录', keep: 'break_record' },
      },
      {
        path: 'sales',
        component: () => import('@/pages/crm/contractSales/contractSales.vue'),
        meta: { title: '租售合同', keep: 'contractSales' },
      },
      {
        path: 'sales/add',
        component: () => import('@/pages/crm/contractComponents/salesContract_item.vue'),
        meta: { title: '新增租售合同', keep: 'salesContract_item' },
      },
      {
        path: 'sales/edit',
        component: () => import('@/pages/crm/contractComponents/salesContract_item.vue'),
        meta: { title: '编辑租售合同', keep: 'salesContract_item' },
      },
    ],
  },
  {
    path: '/offer',
    component: layout,
    meta: '价格方案',
    children: [
      { path: 'contractlease', component: () => import('@/pages/crm/contractLease/contract_lease.vue'), meta: { title: '租赁方案', keep: 'contractlease' } },
      { path: 'contractlease/add', component: () => import('@/pages/crm/contractLeaseItem/contract_lease_item.vue'), meta: { title: '新增租赁方案', keep: 'contract_lease_item' } },
      { path: 'contractlease/edit', component: () => import('@/pages/crm/contractLeaseItem/contract_lease_item.vue'), meta: { title: '编辑租赁方案', keep: 'contract_lease_item' } },
      { path: 'contractleaseorder', component: () => import('@/pages/crm/contractLeaseOrder/contract_lease_order.vue'), meta: { title: '租赁订单', keep: 'contractleaseorder' } },
      { path: 'contractstock', component: () => import('@/pages/crm/contract/contract_stock.vue'), meta: { title: '库存费方案', keep: 'contract_contractstock' } },
      { path: 'contractrule', component: () => import('@/pages/crm/contract/contract_rule.vue'), meta: { title: '分成规则', keep: 'contract_contractrule' } },
      { path: 'contractrule/add', component: () => import('@/pages/crm/contract/children/contract_rule_item.vue'), meta: { title: '新增分成规则', keep: 'contract_rule_item' } },
      { path: 'contractrule/edit', component: () => import('@/pages/crm/contract/children/contract_rule_item.vue'), meta: { title: '编辑分成规则', keep: 'contract_rule_item' } },
      { path: 'deviceTypeRule', component: () => import('@/pages/crm/offer/deviceTypeRule.vue'), meta: { title: '设备类型规则', keep: 'deviceTypeRule' } },
      { path: 'deviceTypeRule/add', component: () => import('@/pages/crm/offer/children/device_type_rule_item.vue'), meta: { title: '新增规则', keep: 'device_type_rule_item' } },
      { path: 'deviceTypeRule/edit', component: () => import('@/pages/crm/offer/children/device_type_rule_item.vue'), meta: { title: '编辑规则', keep: 'device_type_rule_item' } },
      { path: 'giftPartScheme', component: () => import('@/pages/crm/giftPartScheme/giftPartScheme.vue'), meta: { title: '赠送配件方案', keep: 'gift_part_scheme' } },
      { path: 'deviceChangeRule', component: () => import('@/pages/crm/offer/deviceChangeRule.vue'), meta: { title: '设备更换规则', keep: 'deviceChangeRule' } },
      { path: 'deviceChangeRule/add', component: () => import('@/pages/crm/offer/children/device_change_rule_item.vue'), meta: { title: '新增更换规则', keep: 'device_change_rule_item' } },
      { path: 'deviceChangeRule/edit', component: () => import('@/pages/crm/offer/children/device_change_rule_item.vue'), meta: { title: '编辑更换规则', keep: 'device_change_rule_item' } },
    ],
  },
  {
    path: '/electron',
    component: layout,
    meta: { title: '电子合同' },
    children: [
      {
        path: 'signer',
        component: () => import('@/pages/crm/contract/contract_signer.vue'),
        meta: { title: '待签署合同', keep: 'contract_signer' },
      },
      {
        path: 'sender',
        component: () => import('@/pages/crm/contract/contract_sender.vue'),
        meta: { title: '已发送合同', keep: 'contract_sender' },
      },
    ],
  },
  {
    path: '/crmStock',
    component: layout,
    meta: { title: '库存管理' },
    children: [
      {
        path: 'manage',
        component: () => import('@/pages/crm/stock/stock.vue'),
        meta: { title: '实时库存', keep: 'crmStock' },
      },
      {
        path: 'contractreceive',
        component: () => import('@/pages/crm/contract/contract_receive.vue'),
        meta: { title: '合同收货', keep: 'contractreceive' },
      },
      {
        path: 'contractInventoryPicking',
        component: () => import('@/pages/crm/contract/contract_inventory_picking.vue'),
        meta: { title: '库存调拨', keep: 'contractInventoryPicking' },
      },

      {
        path: 'renovateApplyRecord',
        component: () => import('@/pages/crm/renovateApplyRecord/renovateApplyRecord.vue'),
        meta: { title: '库存延期记录', keep: 'renovateApplyRecord' },
      },
      {
        path: 'delayApplyRecord',
        component: () => import('@/pages/crm/stockDelayApplyRecord/stockDelayApplyRecord.vue'),
        meta: { title: '翻新申请记录', keep: 'stockDelayApplyRecord' },
      },
      {
        path: 'ship',
        component: () => import('@/pages/crm/ship/ship.vue'),
        meta: { title: '发货计划', keep: 'ship' },
      },
      {
        path: 'deviceReceiptRecord',
        component: () => import('@/pages/crm/deviceReceiptRecord/deviceReceiptRecord.vue'),
        meta: { title: '设备签收记录', keep: 'deviceReceiptRecord' },
      },
      // 赠送配件订单
      {
        path: 'freeAccessoriesOrder',
        component: () => import('@/pages/crm/freeAccessoriesOrder/freeAccessoriesOrder.vue'),
        meta: { keep: 'freeAccessoriesOrder' },
      },
      {
        path: 'renovateRecord',
        component: () => import('@/pages/crm/renovateRecord/renovateRecord.vue'),
        meta: { title: '设备翻新记录', keep: 'renovateRecordSc' },
      },
    ],
  },

  {
    path: '/accessory',
    component: layout,
    meta: { title: '赠送配件管理' },
    children: [
      {
        path: 'cost',
        component: () => import('@/pages/crm/accessoryCost/accessoryCost.vue'),
        meta: { title: '配件成本分摊', keep: 'accessoryCost' },
      },
      {
        path: 'partsInventoryRecords',
        component: () => import('@/pages/fms/partsInventoryRecords/partsInventoryRecords.vue'),
        meta: { title: '配件存留记录', keep: 'partsInventoryRecords' }
      },
    ],
  },
  {
    path: '/customer',
    component: layout,
    meta: { title: '客户管理' },
    children: [
      { path: 'renter', component: () => import('@/pages/crm/renter/renter.vue'), meta: { title: '租赁方', keep: 'renter' } },
      { path: 'renter/add', component: () => import('@/pages/crm/renter/children/renter_item.vue'), meta: { title: '新增租赁方', keep: 'renter_item' } },
      { path: 'renter/edit', component: () => import('@/pages/crm/renter/children/renter_item.vue'), meta: { title: '编辑租赁方', keep: 'renter_item' } },
      { path: 'renterDetail', component: () => import('@/pages/crm/renter/children/renter_detail.vue'), meta: { title: '查看租赁方' } },
      { path: 'renter/examine', component: () => import('@/pages/crm/renter/children/renter_examine.vue'), meta: { title: '租赁方信息审核', keep: 'renter_examine' } },
      { path: 'renter/verified', component: () => import('@/pages/crm/components/partnerCommon/company_verified.vue'), meta: { title: '审批实名认证', keep: 'renter_verified' } },
      { path: 'renter/adduser', component: () => import('@/pages/base/userItem/user_item.vue'), meta: { title: '新增用户', keep: 'user_item' } },
      { path: 'renter/edituser', component: () => import('@/pages/base/userItem/user_item.vue'), meta: { title: '编辑用户', keep: 'user_item' } },
      { path: 'groupCustomer', component: () => import('@/pages/crm/groupCustomer/groupCustomer.vue'), meta: { title: '集团客户', keep: 'groupCustomer' } },
      { path: 'groupCustomer/add', component: () => import('@/pages/crm/groupCustomer/children/groupCustomer_item.vue'), meta: { title: '新增集团客户', keep: 'groupCustomer_item' } },
      { path: 'groupCustomer/edit', component: () => import('@/pages/crm/groupCustomer/children/groupCustomer_item.vue'), meta: { title: '编辑集团客户', keep: 'groupCustomer_item' } },
      { path: 'groupCustomer/detail', component: () => import('@/pages/crm/groupCustomer/children/groupCustomer_detail.vue'), meta: { title: '查看集团客户' } },
      { path: 'groupCustomer/adduser', component: () => import('@/pages/base/userItem/user_item.vue'), meta: { title: '新增用户', keep: 'user_item' } },
      { path: 'groupCustomer/edituser', component: () => import('@/pages/base/userItem/user_item.vue'), meta: { title: '编辑用户', keep: 'user_item' } },
      { path: 'groupCustomer/verified', component: () => import('@/pages/crm/components/partnerCommon/company_verified.vue'), meta: { title: '审核实名认证' } },
      {
        path: 'groupRelation',
        component: () => import('@/pages/crm/groupRelation/groupRelation.vue'),
        meta: { title: '集团客户关系管理', keep: 'groupRelation' },
      },
    ],
  },
  {
    path: '/distributor',
    component: layout,
    meta: { title: '经销商' },
    children: [
      { path: 'serviceCompany', component: () => import('@/pages/crm/serviceCompany/serviceCompany.vue'), meta: { title: '服务公司', keep: 'serviceCompany' } },
      { path: 'serviceCompany/add', component: () => import('@/pages/crm/serviceCompany/children/company_item.vue'), meta: { title: '新增服务公司', keep: 'company_item' } },
      { path: 'serviceCompany/edit', component: () => import('@/pages/crm/serviceCompany/children/company_item.vue'), meta: { title: '编辑服务公司', keep: 'company_item' } },
      { path: 'serviceCompany/detail', component: () => import('@/pages/crm/serviceCompany/children/company_detail.vue'), meta: { title: '查看服务公司' } },
      { path: 'serviceCompany/adduser', component: () => import('@/pages/base/userItem/user_item.vue'), meta: { title: '新增用户', keep: 'user_item' } },
      { path: 'serviceCompany/edituser', component: () => import('@/pages/base/userItem/user_item.vue'), meta: { title: '编辑用户', keep: 'user_item' } },
      { path: 'serviceCompany/verified', component: () => import('@/pages/crm/components/partnerCommon/company_verified.vue'), meta: { title: '审批实名认证' } },
      { path: 'serviceCompany/renterAdd', component: () => import('@/pages/crm/renter/children/renter_item.vue'), meta: { title: '新增租赁方', keep: 'renter_item' } },
      { path: 'factory', component: () => import('@/pages/crm/factory/factory.vue'), meta: { title: '总部管理', keep: 'factory' } },
      { path: 'factory/add', component: () => import('@/pages/crm/factory/children/factory_item.vue'), meta: { title: '新增总部', keep: 'factory_item' } },
      { path: 'factory/edit', component: () => import('@/pages/crm/factory/children/factory_item.vue'), meta: { title: '编辑总部', keep: 'factory_item' } },
      { path: 'factory/detail', component: () => import('@/pages/crm/factory/children/factory_detail.vue'), meta: { title: '查看总部' } },
      { path: 'factory/adduser', component: () => import('@/pages/base/userItem/user_item.vue'), meta: { title: '新增用户', keep: 'user_item' } },
      { path: 'factory/edituser', component: () => import('@/pages/base/userItem/user_item.vue'), meta: { title: '编辑用户', keep: 'user_item' } },
      { path: 'factory/verified', component: () => import('@/pages/crm/components/partnerCommon/company_verified.vue'), meta: { title: '审批实名认证' } },
    ],
  },
  {
    path: '/companyInfo',
    component: layout,
    meta: { title: '公司信息' },
    children: [
      {
        path: 'msg',
        component: () => import('@/pages/crm/companyMsg/companyMsg.vue'),
        meta: { title: '公司信息', keep: 'companyMsg' },
      },
      {
        path: 'seal',
        component: () => import('@/pages/crm/companySeal/companySeal.vue'),
        meta: { title: '公司印章', keep: 'companySeal' },
      },
      {
        path: 'address',
        component: () => import('@/pages/crm/financeAddress/financeAddress.vue'),
        meta: { title: '收货地址管理', keep: 'financeAddress' },
      },
    ],
  },
  // 售后管理
  {
    path: '/paramSet',
    component: layout,
    meta: { title: '参数设置' },
    children: [
      { path: 'cycleManage', component: () => import('@/pages/asm/paramSet/maintain_cycle_manage.vue'), meta: { title: '保养周期设置', keep: 'maintain_cycle_manage' } },
      { path: 'maintainManage', component: () => import('@/pages/asm/paramSet/maintain_manage.vue'), meta: { titile: '服务项', keep: 'maintain_manage' } },
      { path: 'maintainManage/maintain_item_watch', component: () => import('@/pages/asm/paramSet/children/maintain_item_watch.vue'), meta: { title: '保养项目详情', keep: 'maintain_item_watch' } },
      { path: 'partsLocation', component: () => import('@/pages/asm/partsLocation/partsLocation.vue'), meta: { titile: '', keep: 'partsLocation' } },
    ],
  },
  {
    path: '/afterSalesSet',
    component: layout,
    meta: { title: '售后设置' },
    children: [
      { path: 'aftersale', component: () => import('@/pages/asm/paramSet/factory_aftersale.vue'), meta: { title: '售后主管', keep: 'factory_aftersale' } },
      { path: 'userAfterSale', component: () => import('@/pages/asm/userAfterSale/userAfterSale.vue'), meta: { titile: '售后工程师', keep: 'userAfterSale' } },
      { path: 'aftersalePerson', component: () => import('@/pages/asm/paramSet/aftersale_person.vue'), meta: { titile: '设备负责人', keep: 'aftersale_person' } },
    ],
  },
  {
    path: '/part',
    component: layout,
    meta: { title: '零件管理' },
    children: [
      { path: 'base', component: () => import('@/pages/asm/partManage/part_base.vue'), meta: { title: '零件资料', keep: 'partBase' } },
      { path: 'life', component: () => import('@/pages/asm/partManage/part_life.vue'), meta: { titile: '零件寿命', keep: 'partLife' } },
      { path: 'unregister', component: () => import('@/pages/asm/partManage/part_unregister.vue'), meta: { titile: '零件更换未登记', keep: 'partUnregister' } },
    ],
  },
  {
    path: '/workorder',
    component: layout,
    meta: { titile: '工单管理' },
    children: [
      { path: 'my', component: () => import('@/pages/asm/workManage/my_workorder.vue'), meta: { title: '工单管理', keep: 'my_workorder' } },
      { path: 'wait', component: () => import('@/pages/asm/workManage/wait_workorder.vue'), meta: { title: '', keep: 'wait_workorder' } },
      { path: 'caseOrder', component: () => import('@/pages/asm/workManage/case_order.vue'), meta: { title: '案例订单', keep: 'caseOrder' } },
      { path: 'caseOrderDetail', component: () => import('@/pages/asm/workManage/case_order_detail.vue'), meta: { title: '查看案例' } },
      { path: 'workOrderDetail', component: () => import('@/pages/asm/workManage/case_order_detail.vue'), meta: { title: '查看工单' } },
      { path: 'detail', component: () => import('@/pages/asm/partManage/part_detail.vue'), meta: { title: '零件更换记录', keep: 'partDetail' } },

      { path: 'feedBack', component: () => import('@/pages/asm/feedBackManage/feedBackManage.vue'), meta: { title: '质量反馈', keep: 'feedBackManage' } },
      { path: 'feedBackDetail', component: () => import('@/pages/asm/feedBackDetail/feedBackDetail.vue'), meta: { titile: '查看质量反馈', keep: 'feedBackDetail' } },
    ],
  },
  {
    path: '/fault',
    component: layout,
    children: [
      {
        path: 'manage',
        component: () => import('@/pages/asm/fault/fault.vue'),
        meta: { title: '故障列表', keep: 'faultManage' },
      },
      {
        path: 'offlineDevice',
        component: () => import('@/pages/asm/fault/offlineDevice.vue'),
        meta: { title: '离线设备', keep: 'offlineDevice' },
      },
      // 锁机清洁设备
      {
        path: 'lockCleanDevice',
        component: () => import('@/pages/asm/fault/lockCleanDevice.vue'),
        meta: { title: '锁机清洁设备', keep: 'lockCleanDevice' },
      },
      {
        path: 'batteryMalfunction',
        component: () => import('@/pages/asm/fault/batteryMalfunction.vue'),
        meta: { title: '电池异常设备', keep: 'batteryMalfunction' },
      },
      // { path: 'offlineDevice', component: () => import('@/pages/asm/workManage/offline_device.vue'), meta: { title: '离线设备', keep: 'offlineDevice' } },
      // { path: 'offline', component: () => import('@/pages/asm/offlineStatistics/offline_statistics.vue'), meta: { title: '不在线统计', keep: 'offline' } }
    ],
  },
  {
    path: '/offline',
    component: layout,
    meta: { titile: '线下服务' },
    children: [
      { path: 'service', component: () => import('@/pages/asm/offlineService/offlineService.vue'), meta: { title: '线下服务', keep: 'offlineService' } },
      { path: 'serviceAdd', component: () => import('@/pages/asm/offlineService/children/offlineService_addItem.vue'), meta: { title: '新增服务', keep: 'offlineService_addItem' } },
      { path: 'record', component: () => import('@/pages/asm/offlineRecord/offlineRecord.vue'), meta: { title: '质量反馈', keep: 'offlineService' } },
    ],
  },

  // 财务管理
  {
    path: '/receive',
    component: layout,
    meta: { title: '应收管理' },
    children: [
      { path: 'receiveRefund', component: () => import('@/pages/fms/receive/receive_refund.vue'), meta: { title: '应收退款', keep: 'receiveRefund' } },
      { path: 'deposit', component: () => import('@/pages/fms/receive/receive_deposit.vue'), meta: { title: '应收押金', keep: 'receiveDeposit' } },

      { path: 'receiveOrder', component: () => import('@/pages/fms/receiveManage/receive_order.vue'), meta: { title: '应收账单', keep: 'receiveOrder' } },
      { path: 'receiveBill', component: () => import('@/pages/fms/receiveManage/receive_bill.vue'), meta: { title: '应收订单', keep: 'receiveBill' } },
    ],
  },
  {
    path: '/pay',
    component: layout,
    meta: { title: '应付管理' },
    children: [
      { path: 'deposit', component: () => import('@/pages/fms/pay/pay_deposit.vue'), meta: { title: '应付押金', keep: 'payDeposit' } },
      { path: 'refund', component: () => import('@/pages/fms/payRefund/pay_refund.vue'), meta: { title: '应退租金', keep: 'payRefund' } },
      { path: 'payOrder', component: () => import('@/pages/fms/payManage/pay_order.vue'), meta: { title: '应付账单', keep: 'payOrder' } },
      { path: 'payBill', component: () => import('@/pages/fms/payManage/pay_bill.vue'), meta: { title: '应付订单', keep: 'payBill' } },
    ],
  },
  {
    path: '/invoice',
    component: layout,
    meta: { title: '发票管理' },
    children: [
      { path: 'invoiceManage', component: () => import('@/pages/fms/invoiceManage/invoiceManage.vue'), meta: { title: '开票管理', keep: 'invoiceManage' } },
      { path: 'invoiceReceive', component: () => import('@/pages/fms/invoiceReceive/invoiceReceive.vue'), meta: { title: '收票管理', keep: 'invoiceReceive' } },
      { path: 'invoiceBody', component: () => import('@/pages/fms/invoiceBody/invoiceBody.vue'), meta: { title: '发票主体', keep: 'invoiceBody' } },
    ],
  },
  {
    path: '/',
    component: layout,
    meta: { title: '银行卡管理' },
    children: [{ path: 'bankCard', component: () => import('@/pages/fms/bankCard/bankCard.vue'), meta: { title: '银行卡管理', keep: 'bankcard' } }],
  },
  {
    path: '/',
    component: layout,
    meta: { title: '交易记录' },
    children: [{ path: 'bankFlow', component: () => import('@/pages/fms/bankFlow/bankFlow.vue'), meta: { title: '交易记录', keep: 'bankFlow' } }],
  },

  {
    path: '/',
    component: layout,
    meta: { title: '余额记录' },
    children: [{ path: 'restRecord', component: () => import('@/pages/fms/restRecord/rest_record.vue'), meta: { title: '余额记录', keep: 'restRecord' } }],
  },
  {
    path: '/',
    component: layout,
    meta: { title: '账单变更记录' },
    children: [{ path: 'billChangeRecord', component: () => import('@/pages/fms/billChangeRecord/billChangeRecord.vue'), meta: { title: '账单变更记录', keep: 'billChangeRecord' } }],
  },
  {
    path: '/',
    component: layout,
    meta: { title: '账单核销记录' },
    children: [{ path: 'billVerificationRecord', component: () => import('@/pages/fms/billVerificationRecord/billVerificationRecord.vue'), meta: { title: '账单核销记录', keep: 'billVerificationRecord' } }],
  },
  // 其他 ？？？？？
  {
    path: '/',
    component: layout,
    children: [{ path: 'boarddetail', component: () => import('@/pages/dms/boardDetail/boardDetail.vue'), meta: { keep: 'boardDetail' } }],
  },
  // 设备详情
  {
    path: '/',
    component: layout,
    children: [{ path: 'devicedetail', component: () => import('@/pages/dms/deviceDetail/device_detail.vue') }],
  },
  // 查看合同详情
  {
    path: '/',
    component: layout,
    children: [{ path: 'contractdetail', component: () => import('@/pages/crm/contractDetail/contract_detail.vue') }],
  },
  // 查看调拨单详情
  {
    path: '/',
    component: layout,
    children: [{ path: 'contractInvTransDetail', component: () => import('@/pages/crm/contract/contract_inv_trans_detail.vue'), meta: { title: '调拨单详情' } }],
  },
  {
    path: '/',
    component: layout,
    children: [{ path: 'identification', component: () => import('@/pages/crm/companyMsg/identification.vue'), meta: { title: '企业实名认证', keep: 'identification' } }],
  },
  // 培训管理
  {
    path: '/',
    component: layout,
    children: [
      { path: 'tutorial', component: () => import('@/pages/training/tutorial/tutorial.vue'), meta: { keep: 'tutorial' } },
      { path: 'tutorial/add', component: () => import('@/pages/training/tutorial/children/tutorial_item.vue'), meta: { keep: 'tutorial_item' } },
      { path: 'tutorial/edit', component: () => import('@/pages/training/tutorial/children/tutorial_item.vue'), meta: { keep: 'tutorial_item' } },
    ],
  },
  // 数据分析
  {
    path: '/',
    component: layout,
    children: [{ path: 'financeBizReport', component: () => import('@/pages/report/financeBiz/financeBiz.vue'), meta: { keep: 'financeBiz' } }],
  },
  // 客服报表
  {
    path: '/',
    component: layout,
    children: [{ path: 'customerBizReport', component: () => import('@/pages/report/customerBizReport/customerBizReport.vue'), meta: { keep: 'customerBizReport' } }],
  },
  {
    path: '/',
    component: layout,
    children: [{ path: 'runLog', component: () => import('@/pages/report/runLog/runLog.vue'), meta: { keep: 'report' } }],
  },
  {
    path: '/',
    component: layout,
    children: [{ path: 'robotLog', component: () => import('@/pages/report/robotLog/robotLog.vue'), meta: { keep: 'robotLog' } }],
  },
  {
    path: '/',
    component: layout,
    children: [{ path: 'serviceCompanyShare', component: () => import('@/pages/report/serviceCompanyShare/serviceCompanyShare.vue'), meta: { keep: 'robotLog' } }],
  },
  {
    path: '/',
    component: layout,
    children: [{ path: 'lockingMachineRecord', component: () => import('@/pages/report/lockingMachineRecord/lockingMachineRecord.vue'), meta: { keep: 'lockingMachineRecord' } }],
  },

  // AI基础配置
  {
    path: '/aiBasic',
    component: layout,
    meta: { title: 'AI基础配置' },
    children: [{ path: 'dataTable', component: () => import('@/pages/dms/aiDataTable/aiDataTable.vue'), meta: { title: '数据表', keep: 'aiDataTable' } }],
  },
  // 404页面
  { path: '*', component: () => import('@/pages/login/notfound.vue'), meta: {} },
];
